import { Route, Routes } from 'react-router-dom';
import type { ReactNode } from 'react';
import { AuthProvider } from './hooks/useAuth';
import { LocaleProvider, useLocale } from './hooks/useT';
import { BodyRouteClass } from './components/BodyRouteClass';
import { SiteHeader } from './components/SiteHeader';
import { SiteFooter } from './components/SiteFooter';
import { LandingPage } from './pages/LandingPage';
import { PlayPage } from './pages/PlayPage';
import { PracticePage } from './pages/PracticePage';
import { PremiumPage } from './pages/PremiumPage';
import { GalleryPage } from './pages/GalleryPage';
import { CreditsPage } from './pages/CreditsPage';
import { ResultPage } from './pages/ResultPage';
import { LeaderboardPage } from './pages/LeaderboardPage';
import { LoginPage } from './pages/LoginPage';
import { AuthCallbackPage, AuthVerifyPage } from './pages/AuthPages';
import { ArenaPage } from './pages/ArenaPage';
import { FriendsPage } from './pages/FriendsPage';
import { LeaguesPage } from './pages/LeaguesPage';
import { LeagueDetailPage } from './pages/LeagueDetailPage';
import { LeaguePlayPage } from './pages/LeaguePlayPage';
import { CGUPage } from './pages/legal/CGUPage';
import { CGVPage } from './pages/legal/CGVPage';
import { MentionsLegalesPage } from './pages/legal/MentionsLegalesPage';
import { ConfidentialitePage } from './pages/legal/ConfidentialitePage';
import { ProfilePage } from './pages/ProfilePage';
import { AdminPage } from './pages/AdminPage';

/** Remount UI when locale changes so all `t()` calls pick up the new language. */
function LocalizedShell({ children }: { children: ReactNode }) {
  const { locale } = useLocale();
  return <div key={locale} className="localized-shell">{children}</div>;
}

export function App() {
  return (
    <LocaleProvider>
      <AuthProvider>
        <LocalizedShell>
      <BodyRouteClass />
      <SiteHeader />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/play" element={<PlayPage />} />
        <Route path="/practice" element={<PracticePage />} />
        <Route path="/premium" element={<PremiumPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/credits" element={<CreditsPage />} />
        <Route path="/result" element={<ResultPage />} />
        <Route path="/leaderboard" element={<LeaderboardPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/verify" element={<AuthVerifyPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/friends" element={<FriendsPage />} />
        <Route path="/arena" element={<ArenaPage />} />
        <Route path="/leagues" element={<LeaguesPage />} />
        <Route path="/leagues/:id" element={<LeagueDetailPage />} />
        <Route path="/leagues/:id/play/:puzzleIndex" element={<LeaguePlayPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/cgu" element={<CGUPage />} />
        <Route path="/cgv" element={<CGVPage />} />
        <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
        <Route path="/confidentialite" element={<ConfidentialitePage />} />
      </Routes>
      <SiteFooter />
        </LocalizedShell>
      </AuthProvider>
    </LocaleProvider>
  );
}
